import React from 'react';
import { Outlet, useParams } from 'react-router-dom';
import UnsupportedRegion from '../pages/UnsupportedRegion';
import { isSupportedRegion } from '../regions';

const RegionGuard: React.FC = () => {
  const { region } = useParams();

  if (!region || !isSupportedRegion(region)) {
    return <UnsupportedRegion requestedRegion={region} />;
  }

  return <Outlet />;
};

export default RegionGuard;
